module.exports = __webpack_public_path__ + "img/sieckFinesseRelease6.e5d7157f.png";